import { ReactNode, InputHTMLAttributes } from 'react';
import { formFieldInputClassName } from './formFieldStyles';

interface FormFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  helperText?: string;
  required?: boolean;
  children?: ReactNode;
}

export function FormField({
  label,
  error,
  helperText,
  required,
  children,
  className = '',
  ...inputProps
}: FormFieldProps) {
  return (
    <div className="space-y-1">
      <label className="block text-[12px] font-medium text-slate-600">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {children ? (
        children
      ) : (
        <input
          className={formFieldInputClassName(Boolean(error), className)}
          {...inputProps}
        />
      )}
      {error && <p className="text-[11px] text-red-600">{error}</p>}
      {helperText && !error && <p className="text-[11px] text-slate-500">{helperText}</p>}
    </div>
  );
}

FormField.displayName = 'FormField';
